import { Select } from "antd";
import styled from "styled-components";

//Styled Component
export const SpinnerContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: grid;
  justify-content: center;
  align-items: center;
  background: #dededec4;
  width: 100%;
  height: 100%;
`;

export const ContentContainer = styled.div`
  min-width: 750px;
  max-width: 900px;
  overflow: auto;
`;

export const DashboardsContainer = styled.div`
  overflow-x: auto;
  overflow-y: visible;
`;

export const FormContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr) auto;
  gap: 12px;
  .ant-input {
    border-radius: 5px;
    width: 100%;
  }
  /* The Type field is an input with an icon prefix for standard users, so the affix wrapper
     carries its border — it has to match the plain inputs beside it. */
  .ant-input-affix-wrapper {
    border-radius: 5px;
    width: 100%;
  }
`;

export const FormInput = styled.div``;

export const FormInputLabel = styled.div`
  padding-bottom: 10px;
`;

export const RootContainer = styled.div`
  gap: 10px;
  width: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  text-align: left;
  overflow: auto;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto minmax(0, 1fr);
  .ant-divider-horizontal {
    margin: 5px 0;
  }
  .section {
    padding: 33px 0;
  }
  .section-heading {
    font-size: 1.6rem;
    padding-bottom: 22px;
    font-weight: var(--fontWeightMedium);
    padding: 0;
  }
`;

export const SectionBody = styled.div`
  padding: 33px 0;
`;

export const SelectWrapper = styled(Select)`
  width: 100% !important;
`;

export const WarningContainer = styled.div`
  color: var(--orange);
  font-weight: var(--fontWeightMedium);
`;

export const ErrorContainer = styled.div`
  color: var(--color-danger);
  font-weight: var(--fontWeightMedium);
`;

export const DashboardsLoadingWrapper = styled.div`
  text-align: center;
`;

export const WorkspaceActionButton = styled.button`
  flex: 1 1 auto;
  border: 0;
  padding: 0;
  margin: 0;
  width: 36px;
  height: 36px;
  cursor: pointer;
  background: transparent;
  color: #a2aaad;
  &:hover {
    color: ${(props) => (props.danger ? "var(--color-danger)" : "var(--color-primary)")};
  }
  &:disabled,
  &[disabled] {
    cursor: not-allowed;
    opacity: 0.4;
    &:hover {
      color: #a2aaad;
    }
  }
`;

export * as WorkspaceManagementStyled from "./WorkspaceManagement.styles";
